import { LandingAndStylesRedirectsActionsType } from './actions';

export const URL_REDIRECT = '@REDIRECTS/URL_REDIRECT';
export const UNSET_URL_REDIRECT = '@REDIRECTS/UNSET_URL_REDIRECT';

export interface RedirectState {
    data?: RedirectResponse;
    key: string;
    landingRedirects?: LandingRedirectsData;
    landingRedirectsIsFetching: boolean;
    landingRedirectsFetchingComplete: boolean;
}

export interface RedirectResponse {
    requestPath: string;
    targetPath: string;
    httpCode: number;
    source: string;
}

export interface LandingPageRedirectsResponse {
    success: boolean;
    data?: LandingRedirectsData;
}

export interface LandingRedirectsData {
    landings: {
        [key: string]: Array<string>;
    };
    // Todo(P100-3749) remove this property
    styles: {
        [key: string]: Array<string>;
    };
}

export interface UrlRedirectAction {
    type: typeof URL_REDIRECT | typeof UNSET_URL_REDIRECT;
    payload: RedirectResponse;
}

export type RedirectActionTypes = UrlRedirectAction | LandingAndStylesRedirectsActionsType;
